import { render } from "./modalsReserveComponent.vue?vue&type=template&id=6b22de42"
import script from "./modalsReserveComponent.vue?vue&type=script&lang=js"
export * from "./modalsReserveComponent.vue?vue&type=script&lang=js"

import "./modalsReserveComponent.vue?vue&type=style&index=0&id=6b22de42&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__